import AppSelecionarContaBancariaDialog from '../../../../shared/dialogs/SelecionarContaBancariaDialog.vue';
import { mapActions, mapState } from 'vuex';
import util from '../../../../util/funcoes.js'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { TIPO_REGISTRO_CORA, TIPO_TRANSACAO_ASAAS, TIPO_TRANSACAO_CORA } from '../../../../util/constantes.js'

export default {
  components: {
    AppSelecionarContaBancariaDialog,
    FontAwesomeIcon
  },

  data() {
    return {
      activeIndex: "boletos",

      contaBancaria: { nome: undefined },

      visibilidadeSelecionarContaBancariaDialog: false,

      isCollapse: true,
      isLoadingSaldo: false,
      isLoadingBoletos: false,
      isLoadingExtrato: false,

      tabAtiva: 'WAIT_SCREEN',

      formPesquisa: {
        dataInicio: undefined,
        dataFinal: undefined,
        status: 'OPEN',
        cliente: undefined,

        tipoRegistro: undefined,
        tipoTransacao: undefined,
      },

      statusTituloCora: [
        { label: 'Cancelado', data: 'CANCELLED' },
        { label: 'Em Atraso', data: 'LATE' },
        { label: 'Registrado', data: 'OPEN' },
        { label: 'Pago', data: 'PAID' },
      ],

      statusTituloAsaas: [
        { label: 'Em Atraso', data: 'OVERDUE' },
        { label: 'Registrado', data: 'PENDING' },
        { label: 'Pago', data: 'RECEIVED' }
      ],

      clientes: undefined,
      loadingCliente: false,

      //PAGINAÇÃO
      currentPageTitulos: 1,
      maxItensTitulos: 20,

      currentPageMovimentacoes: 1,
      maxItensMovimentacoes: 20,
    }
  },

  computed: {
    ...mapState('controleRegistroApiStore', {
      saldoConta(state) { return state.saldoConta },
      titulos(state) { return state.titulos },
      extrato(state) { return state.extrato },
      
      quantidadeTotalTitulos(state) { return state.titulos.length },
      titulosFiltrados(state) { return state.titulos.slice(this.paginaAtualTitulosParaIndice * this.maxItensTitulos, this.currentPageTitulos * this.maxItensTitulos)},
      
      quantidadeTotalTransacoes(state) { return state.extrato.movimentacoes.length },
      movimentacoesFiltradas(state) { return state.extrato.movimentacoes.slice(this.paginaAtualMovimentacoesParaIndice * this.maxItensTitulos, this.currentPageMovimentacoes * this.maxItensMovimentacoes)},
    }),
    ...mapState("loginStore", {
      usuarioLogado(state) {
        return state.usuarioLogado;
      }
    }),
    tipoRegistroCora() { return TIPO_REGISTRO_CORA },
    tipoTransacaoCora() { return TIPO_TRANSACAO_CORA },
    tipoTransacaoAsaas() { return TIPO_TRANSACAO_ASAAS },
    
    paginaAtualTitulosParaIndice() {
      return this.currentPageTitulos - 1;
    },
    paginaAtualMovimentacoesParaIndice() {
      return this.currentPageMovimentacoes - 1;
    },

    labelQuantidadeTitulos() {
      switch (this.quantidadeTotalTitulos) {
        case 1:
          return `${this.quantidadeTotalTitulos} Boleto encontrado`
        case 0:
          return '';
        default:
          return `Exibindo ${this.paginaAtualTitulosParaIndice * this.maxItens + 1} a ${this.titulosFiltrados.length + this.paginaAtualTitulosParaIndice * this.maxItens} de ${this.quantidadeTotalTitulos} Boletos`
      }
    },

    labelQuantidadeMovimentacoes() {
      switch (this.quantidadeTotalTransacoes) {
        case 1:
          return `${this.quantidadeTotalTransacoes} Boleto encontrado`
        case 0:
          return '';
        default:
          return `Exibindo ${this.paginaAtualMovimentacoesParaIndice * this.maxItens + 1} a ${this.movimentacoesFiltradas.length + this.paginaAtualMovimentacoesParaIndice * this.maxItens} de ${this.quantidadeTotalTransacoes} Boletos`
      }
    },

    statusTitulo() {
      switch (this.contaBancaria.banco) {
        case 'CORA':
          return this.statusTituloCora
        case 'ASAAS':
          return this.statusTituloAsaas
        default:
          break;
      }
    },

    bancoHasSaldo() {
      return this.contaBancaria.banco === 'CORA'
    },

    isBancoHasTipoRegistro() {
      return ['CORA'].includes(this.contaBancaria.banco)
    },

    isBancoHasTipoTransacao() {
      return ['CORA'].includes(this.contaBancaria.banco)
    }
  },
  methods: {
    ...mapActions('remessasStore', [
      'listarClientes'
    ]),
    ...mapActions('controleRegistroApiStore', [
      'getSaldoCora',
      'listarBoletosCora',
      'pagarTituloCora',
      'cancelarTituloCora',
      'recuperarExtratoCora',
      'listarBoletosAsaas',
      'recuperarExtratoAsaas',
      'cancelarTituloAsaas',
      'atualizarTituloAsaas'
    ]),
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),

    abaBoletos() {
      if(this.contaBancaria.id) {
        this.tabAtiva = 'BOLETOS'
      }
    },

    abaExtrato() {
      if(this.usuarioLogado.perfil != 'ADMINISTRADOR') {
        return;
      }

      if(this.contaBancaria.id) {
        this.tabAtiva = 'EXTRATO'

        switch (this.contaBancaria.banco) {
          case 'CORA':
            if(this.extrato.movimentacoes.length === 0) {
              this.recuperarExtratoCoraHandler()
            }
            break;
          case 'ASAAS':
            if(this.extrato.movimentacoes.length === 0) {
              this.recuperarExtratoAsaasHandler();
            }
            break;
          default:
            break;
        }
      }
    },

    listarExtratoHandler() {
      switch (this.contaBancaria.banco) {
        case 'CORA':
          this.recuperarExtratoCoraHandler();
          break;
        case 'ASAAS':
          this.recuperarExtratoAsaasHandler();
          break;
        default:
          break;
      }
    },

    getSaldoCoraHandler() {
      this.isLoadingSaldo = true;

      this.getSaldoCora(this.contaBancaria)
      .then(response => {
        if(response.status === 'SUCESSO') {
          this.contaBancaria.saldo = response.item;
        }

        if(response.status === 'ERRO') {
          this.$message.error(response.mensagem);
        }

        this.isLoadingSaldo = false;
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.');
        this.isLoadingSaldo = false;
      });

    },

    listarTitulos() {
      switch (this.contaBancaria.banco) {
        case 'CORA':
          if(!['CANCELLED', 'LATE', 'OPEN', 'PAID'].includes(this.formPesquisa.status)) {
            this.formPesquisa.status = 'OPEN'
          }  
          this.listarBoletosCoraHandler();
          break;
        case 'ASAAS': {
          if(!['PENDING', 'OVERDUE', 'RECEIVED'].includes(this.formPesquisa.status)) {
            this.formPesquisa.status = 'PENDING'
          }
          this.listarBoletosAsaasHandler();
          break;
        }
        default:
          break;
      }
    },

    listarBoletosCoraHandler() {
      this.isLoadingBoletos = true;

      const payload = {
        dataInicio: this.formPesquisa.dataInicio,
        dataFinal: this.formPesquisa.dataFinal,
        status: this.formPesquisa.status,
        cliente: this.formPesquisa.cliente,
        contaBancaria: {...this.contaBancaria, saldo: undefined},
      }

      this.listarBoletosCora(payload)
      .then(resposta => {
        switch (resposta.status) {
          case 'SUCESSO':
            this.isLoadingBoletos = false;
            break;
          case 'ERRO':
            this.$message.error(resposta.mensagem);
            this.isLoadingBoletos = false;
            break;
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.');
        this.isLoadingBoletos = false;
      })
    },

    listarBoletosAsaasHandler() {
      this.isLoadingBoletos = true;

      let payload = {
        dataInicio: this.formPesquisa.dataInicio,
        dataFinal: this.formPesquisa.dataFinal,
        status: this.formPesquisa.status,
        cliente: this.formPesquisa.cliente,
        contaBancaria: {...this.contaBancaria, saldo: undefined},
      }

      this.listarBoletosAsaas(payload)
      .then(resposta => {
        switch (resposta.status) {
          case 'SUCESSO':
            this.isLoadingBoletos = false;
            break;
          case 'ERRO':
            this.$message.error(resposta.mensagem);
            this.isLoadingBoletos = false;
            break;
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.');
        this.isLoadingBoletos = false;
      })
    },

    pagarTituloCoraHandler(titulo, index) {
      this.showLoading();
      const payload = {
        ...titulo,
        index: index,
        contaBancaria: {...this.contaBancaria, saldo: undefined}
      }

      this.pagarTituloCora(payload)
      .then(resposta => {
        this.hideLoading();
        switch (resposta.status) {
          case 'SUCESSO':
            this.$message.success(resposta.mensagem);
            break;
          case 'ERRO':
            this.$message.error(resposta.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error('Erro ao comunicar-se com o servidor.')
      })
    },

    atualizarTituloHandler(titulo) {
      this.$confirm("Ao confirmar esta operação o título registrado no banco será atualizado com o mesmo valor que se encontra no sistema Imob.", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.showLoading();

        switch (this.contaBancaria.banco) {
          case 'ASAAS': {
            const payload = {
              ...titulo,
              contaBancaria: this.contaBancaria
            }

            this.atualizarTituloAsaas(payload)
            .then(response => {
              if(response.status === 'SUCESSO') {
                this.$message.success(response.mensagem);
                this.listarTitulos();
              }
              if(response.status === 'ERRO') {
                this.$message.error(response.mensagem);
              }
            }).catch(() => {
              this.$message.error('Erro ao comunicar-se com o servidor.');
            }).finally(() => {
              this.hideLoading();
            })
            break;
          }
          default:
            break;
        }

        this.hideLoading();
      })
    },

    cancelarTituloHandler(titulo, index) {
      switch (this.contaBancaria.banco) {
        case 'CORA':
          this.cancelarTituloCoraHandler(titulo, index);
          break;
        case 'ASAAS':
          this.cancelarTituloAsaasHandler(titulo, index);
          break;
        default:
          break;
      }
    },

    cancelarTituloCoraHandler(titulo, index) {
      this.$confirm("O cancelamento desde título no banco pode ocasionar cobranças conforme normas do mesmo, tem certeza que deseja prosseguir?", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.showLoading();
        const payload = {
          ...titulo,
          index: index,
          contaBancaria: { ...this.contaBancaria, saldo: undefined }
        }

        this.cancelarTituloCora(payload)
        .then(resposta => {
          this.hideLoading();
          switch (resposta.status) {
            case "SUCESSO":
              this.$message.success(resposta.mensagem);
              break;
            case "ERRO":
              this.$message.success(resposta.mensagem);
              break;
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error('Erro ao comunicar-se com o servidor.');
        })
      })
    },

    cancelarTituloAsaasHandler(titulo, index) {
      this.$confirm("O cancelamento desde título no banco pode ocasionar cobranças conforme normas do mesmo, tem certeza que deseja prosseguir?", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.showLoading();
        const payload = {
          ...titulo,
          index: index,
          contaBancaria: { ...this.contaBancaria, saldo: undefined }
        }

        this.cancelarTituloAsaas(payload)
        .then(resposta => {
          this.hideLoading();
          switch (resposta.status) {
            case "SUCESSO":
              this.$message.success(resposta.mensagem);
              break;
            case "ERRO":
              this.$message.success(resposta.mensagem);
              break;
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error('Erro ao comunicar-se com o servidor.');
        })
      })
    },

    recuperarExtratoCoraHandler() {
      this.isLoadingExtrato = true;
      const payload = {
        dataInicio: this.formPesquisa.dataInicio,
        dataFinal: this.formPesquisa.dataFinal,
        tipo: this.formPesquisa.tipoRegistro,
        tipoTransacao: this.formPesquisa.tipoTransacao,
        contaBancaria: {...this.contaBancaria, saldo: undefined}
      }

      this.recuperarExtratoCora(payload)
      .then(response => {
        this.isLoadingExtrato = false;
        if(response.status === 'ERRO') {
          this.$message.error(response.mensagem);
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.')
        this.isLoadingExtrato = false;
      })
    },

    recuperarExtratoAsaasHandler() {
      this.isLoadingExtrato = true;
      const payload = {
        dataInicio: this.formPesquisa.dataInicio,
        dataFinal: this.formPesquisa.dataFinal,
        contaBancaria: {...this.contaBancaria, saldo: undefined}
      }

      this.recuperarExtratoAsaas(payload)
      .then(response => {
        this.isLoadingExtrato = false;
        if(response.status === 'ERRO') {
          this.$message.error(response.mensagem);
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.')
        this.isLoadingExtrato = false;
      })
    },

    exibirSelecionarContaBancariaDialog() {
      this.visibilidadeSelecionarContaBancariaDialog = true
    },
    fecharSelecionarContaBancariaDialog(contaBancaria) {
      this.contaBancaria = contaBancaria
      this.visibilidadeSelecionarContaBancariaDialog = false;
      this.tabAtiva = 'BOLETOS'

      if(contaBancaria.banco === 'CORA') {
        this.getSaldoCoraHandler();
      }

      this.listarTitulos();
    },

    formatarValor(valor) {
      return util.formatarValor(valor);
    },

    filtrarClientesSelect(queryString) {
      let payload = {
        nome: queryString
      }

      this.loadingCliente = true;
      this.listarClientes(payload)
        .then((response) => {
          this.clientes = response.lista;
          this.loadingCliente = false;
        }).catch(() => {
          this.loadingCliente = false;
        })
    },

    limparFiltros() {

      switch (this.contaBancaria.banco) {
        case 'CORA':
          this.formPesquisa = { 
            dataInicio: undefined,
            dataFinal: undefined,
            status: 'OPEN',
            cliente: undefined,
    
            tipoRegistro: undefined,
            tipoTransacao: undefined,
          }
          break;
        case 'ASAAS':
          this.formPesquisa = { 
            dataInicio: undefined,
            dataFinal: undefined,
            status: 'PENDING',
            cliente: undefined,
    
            tipoRegistro: undefined,
            tipoTransacao: undefined,
          }
          break;
        default:
          break;
      }
    },

    formatarDataAsaas(data) {
      return util.dataParaString(new Date(data))
    },

    getLabelStatus(data) {
      switch (this.contaBancaria.banco) {
        case 'CORA':
          return util.getLabel(this.statusTituloCora, data);
        case 'ASAAS':
          return util.getLabel(this.statusTituloAsaas, data);
      }
    },

    getLabelTipoCora(data) {
      return util.getLabel(this.tipoRegistroCora, data);
    },

    getLabelTransacaoCora(data) {
      return util.getLabel(this.tipoTransacaoCora, data);
    },

    getLabelTransacaoAsaas(data) {
      return util.getLabel(this.tipoTransacaoAsaas, data);
    },

    getColorBackgroundStatus(status) {
      switch (this.contaBancaria.banco) {
        case 'CORA':
          switch (status) {
            case "OPEN":
              return "#FF9E29"
            case "PAID":
              return "#4B6EF6";
            case "LATE":
              return "#DF1B1B";
            case "CANCELLED":
              return "#A1A4A8";
          }
          break;
        case 'ASAAS':
          switch (status) {
            case "PENDING":
              return "#FF9E29"
            case "RECEIVED":
              return "#4B6EF6";
            case "OVERDUE":
              return "#DF1B1B";
          }
          break;
        default:
          break;
      }
    }
  }
}